import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import ProjectPage from "./pages/Project";
import PageNotFound from "./pages/PageNotFound";
import BlankPage from "./pages/Blank";
import QuotePage from "./pages/QuotePage";

function Application() {
  return (
    <>
      <Routes>
        <Route index path="/" element={<Home />} />
        <Route exact path="/projects" element={<ProjectPage />} />
        <Route exact path="/quote" element={<QuotePage />} />
        <Route exact path="/blank" element={<BlankPage />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </>
  );
}

export default Application;
